export const APP_LOGO_VARIANT = {
  default: 'default',
  light: 'light',
  black: 'black',
};
